import { Backdrop, CircularProgress } from '@mui/material';

const ProgressBackdrop = ({ isLoading, count }: { isLoading: boolean; count?: String }) => {
  return (
    <Backdrop
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        color: '#fff',
        flexDirection: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <div>
        <CircularProgress />
      </div>
      {count ? <div>{count} 소요될 예정입니다. 잠시만 기다려주세요.</div> : null}
    </Backdrop>
  );
};

export default ProgressBackdrop;
